(function(){
  document.querySelectorAll('.bb-blog').forEach(function(root){

    /* Signal that JS is running, so bb-blog.css can safely hide .rv
       elements before revealing them on scroll. Content is fully
       visible by default in CSS with no JS at all; this class is what
       opts a page into the fade-up animation once we know it's safe. */
    root.classList.add('js-anim');

    /* ── NAV ─────────────────────────────────────────────────────────── */
    var hdr = root.querySelector('.bb-hdr');
    if (hdr) {
      window.addEventListener('scroll', function(){
        hdr.classList.toggle('scrolled', window.scrollY > 40);
      }, { passive: true });
    }
    var burger = root.querySelector('.bb-burger'), mnav = root.querySelector('.bb-mnav');
    if (burger && mnav) {
      burger.addEventListener('click', function(){
        var open = burger.classList.toggle('open');
        mnav.classList.toggle('open', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      mnav.querySelectorAll('a').forEach(function(a){
        a.addEventListener('click', function(){
          burger.classList.remove('open');
          mnav.classList.remove('open');
          burger.setAttribute('aria-expanded', 'false');
        });
      });
    }

    /* ── REVEAL ON SCROLL ────────────────────────────────────────────── */
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1 });
    root.querySelectorAll('.rv').forEach(function(el, i){
      el.style.transitionDelay = (i % 4 * 0.06) + 's';
      io.observe(el);
    });

    /* ── SMOOTH SCROLL FOR IN-PAGE ANCHORS ────────────────────────────── */
    root.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(e){
        var id = a.getAttribute('href').slice(1);
        var t = id ? document.getElementById(id) : null;
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });

    /* ── READING PROGRESS BAR ──────────────────────────────────────────
       Tracks scroll through .art-content specifically, not the whole
       page, so the bar reaches 100% when the article body ends rather
       than when the footer scrolls out of view. */
    var progress = root.querySelector('.bb-progress');
    var articleBody = root.querySelector('.art-content');
    if (progress && articleBody) {
      window.addEventListener('scroll', function(){
        var rect = articleBody.getBoundingClientRect();
        var total = rect.height - window.innerHeight;
        var scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 0));
        var pct = total > 0 ? (scrolled / total) * 100 : 0;
        progress.style.width = pct + '%';
      }, { passive: true });
    }

    /* ── TABLE OF CONTENTS: build from H2s in the article body ────────
       Shopify's rich-text article content has no heading IDs by
       default, so this slugifies each H2's text and assigns an id if
       one isn't already present, then populates both the desktop
       sticky TOC and the mobile <details> TOC. */
    var contentEl = root.querySelector('.art-content');
    var tocList = root.querySelector('.toc-list');
    var tocWrap = root.querySelector('.art-toc');
    var tocMobileList = root.querySelector('#bbTocMobile');
    var tocMobileWrap = root.querySelector('.art-toc-mobile');

    if (contentEl) {
      var heads = contentEl.querySelectorAll('h2');
      if (heads.length) {
        var used = {};
        heads.forEach(function(h, i){
          if (!h.id) {
            var slug = h.textContent.toLowerCase().trim()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/(^-|-$)/g, '');
            if (!slug) slug = 'section-' + i;
            if (used[slug]) { used[slug]++; slug = slug + '-' + used[slug]; }
            else { used[slug] = 1; }
            h.id = slug;
          }
        });

        if (tocList) {
          heads.forEach(function(h){
            var a = document.createElement('a');
            a.href = '#' + h.id;
            a.textContent = h.textContent;
            a.addEventListener('click', function(e){
              e.preventDefault();
              h.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
            tocList.appendChild(a);
          });
        }
        if (tocMobileList) {
          heads.forEach(function(h){
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = '#' + h.id;
            a.textContent = h.textContent;
            a.addEventListener('click', function(e){
              e.preventDefault();
              h.scrollIntoView({ behavior: 'smooth', block: 'start' });
              if (tocMobileWrap) tocMobileWrap.removeAttribute('open');
            });
            li.appendChild(a);
            tocMobileList.appendChild(li);
          });
        }

        if (tocWrap) tocWrap.hidden = false;
        if (tocMobileWrap) tocMobileWrap.hidden = false;

        var tio = new IntersectionObserver(function(entries){
          entries.forEach(function(en){
            if (en.isIntersecting && tocList) {
              tocList.querySelectorAll('a').forEach(function(a){
                a.classList.toggle('active', a.getAttribute('href') === '#' + en.target.id);
              });
            }
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        heads.forEach(function(h){ tio.observe(h); });
      }
    }

    /* ── FAQ ACCORDION ─────────────────────────────────────────────────
       Only one open at a time, scoped to this article's FAQ list so it
       doesn't interfere if more than one accordion ever exists on a
       page. */
    var faqSection = root.querySelector('.art-faq');
    if (faqSection) {
      faqSection.querySelectorAll('.art-faq-q').forEach(function(btn){
        btn.addEventListener('click', function(){
          var item = btn.parentElement;
          var wasOpen = item.classList.contains('open');
          faqSection.querySelectorAll('.art-faq-item.open').forEach(function(i){ i.classList.remove('open'); });
          if (!wasOpen) item.classList.add('open');
        });
      });
    }

    /* ── COPY LINK ─────────────────────────────────────────────────────── */
    var copyBtn = root.querySelector('[data-bb-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function(e){
        e.preventDefault();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(window.location.href).then(function(){
            var original = copyBtn.textContent;
            copyBtn.textContent = 'Copied!';
            setTimeout(function(){ copyBtn.textContent = original; }, 1800);
          });
        }
      });
    }

  });
})();